import _ from 'lodash'
import api from './api'
import apiFactory from './api-factory'
import {
  hydrate as profileHydrate,
  dehydrate as profileDehydrate,
} from './profile'
import {
  hydrate as observerHydrate,
  dehydrate as observerDehydrate,
} from './observer'
import {
  hydrate as expertHydrate,
  dehydrate as expertDehydrate,
} from './expert'

const user = {
  ...apiFactory('/api/accounts/user/', ['create', 'partialUpdate', 'update'], {
    hydrate,
    dehydrate,
    errorsDehydrate,
  }),

  getCountPendingStats() {
    return api.get('/api/pending_items').then(({ data }) => data)
  },
}

export function dehydrate({
  pk,
  firstName,
  lastName,
  username,
  lastLogin,
  dateJoined,
  email,
  expert,
  profile,
  observer,
}) {
  return {
    pk,
    firstName,
    lastName,
    username,
    lastLogin,
    dateJoined,
    email,
    profile: profile && profileDehydrate(profile),
    expert: expert && expertDehydrate(expert),
    observer: observer && observerDehydrate(observer),
  }
}

export function hydrate({
  pk,
  firstName,
  lastName,
  username,
  email,
  profile,
  expert,
  observer,
}) {
  return {
    pk,
    firstName,
    lastName,
    username,
    email,
    profile: profile && profileHydrate(profile),
    expert: expert && expertHydrate(expert),
    observer: observer && observerHydrate(observer),
  }
}

function errorsDehydrate(errors) {
  return {
    ...errors,
    user: _.omit(errors, ['profile', 'observer', 'expert']),
    profile: errors.profile,
  }
}

export default user
